<template>
  <div v-role="roles">
    <div>
      <div class="formPosition">
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <template>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-container class="text-md-left">
              <v-row no-gutters>
                <v-col md="12">
                  <v-card>
                    <v-list flat>
                      <v-header>
                        <v-row>
                          <v-col md="12">
                            <v-row>
                              <v-col md="6">
                                  <v-card-title class="d-flex align-center">
                                         <span class="text-h6">Lançamento de notas anteriores • {{ descricaoNota }}</span>

                                        <v-chip
                                          v-if="anolectivoSelected !== null"
                                          color="grey lighten-4"
                                          class="ml-2"
                                        >
                                          {{ anolectivoSelected.novadescricao }}
                                        </v-chip>
 
                                      </v-card-title>




                                    <v-snackbar
                                      v-model="snackbar"
                                      centered
                                      right
                                       color="info"
                                    >
                                      {{ text }}

                                      <template v-slot:action="{ attrs }">
                                        <v-btn
                                          color="red"
                                          text
                                          v-bind="attrs"
                                          @click="snackbar = false"
                                        >
                                          Fechar
                                        </v-btn>
                                      </template>
                                  </v-snackbar>

                              </v-col>
                              <v-col
                                md="3"
                                v-if="!$store.state.hasMessage"
                              ></v-col>
                              <v-col md="3" v-if="$store.state.hasMessage">
                                <div
                                  :style="estiloPauta"
                                  v-if="$store.state.hasMessage"
                                  :class="$store.state.classMessage"
                                >
                                  {{ $store.state.textMessage }}
                                </div>
                              </v-col>

                              <v-col md="2">
                                <v-btn
                                    color="primary"
                                    class="white--text font-weight-bold"
                                      @click="iniciarTourNotas()"
                                    small
                                    style="float:right;"
                                    text
                                  >
                                    <v-icon left small>mdi-help-circle</v-icon>
                                    Guia de Lançamento de Notas
                                  </v-btn>
                              </v-col>
                            </v-row>

                  <v-card-text class="pa-4">
            <!-- Linha 1: Período Acadêmico -->
            <v-row dense class="mb-4">
              <v-col cols="12" class="py-1">
                <v-chip
                  label
                  color="blue lighten-5"
                  text-color="blue darken-2"
                  class="font-weight-medium text-caption mb-2"
                  small
                >
                  PERÍODO ACADÊMICO E TIPO DE NOTA
                </v-chip>
              </v-col>

              <v-col md="3">
                  <v-combobox  :items="Listaranoslectivo" v-model="anolectivoSelected" outlined dense @change="selectAnolectivo()"
                    label="Selecione o anolectivo" item-text="novadescricao" item-value="id" data-tour="anolectivo"
                    return-object>
                  </v-combobox>
              </v-col>

              <v-col md="3">
                <v-combobox :items="tiposNota" v-model="tipoNotaSelected" outlined dense @change="selectTipoNota()"
                    label="Selecione o tipo de nota" item-text="descricao" item-value="id" data-tour="tiponota"
                    return-object>
                  </v-combobox>
              </v-col>
            </v-row>

           

  <v-divider v-if="isAnolectivoNotaSelected || tourNotasAtivo" class="my-2"></v-divider>

  <!-- Linha 2: Turma e Disciplina -->
  <v-row dense v-if="isAnolectivoNotaSelected || tourNotasAtivo">
    <v-col cols="12" class="py-1">
      <v-chip
        label
        color="green lighten-5"
        text-color="green darken-2"
        class="font-weight-medium text-caption mb-2"
        small
      >
        TURMA E DISCIPLINA
      </v-chip>
    </v-col>

    <v-col md="3">
      <v-combobox
        :items="classesFiltered"
        v-model="classeSelected"
        item-text="descricao"
        label="Classe"
        return-object
        @change="filtrarTurmas"
        placeholder="Classe"
        outlined
        dense
        hide-details
        data-tour="classe"
      ></v-combobox>
    </v-col>

    <v-col md="3">
      <v-combobox
        :items="turmasFilter"
        v-model="turmaSelected"
        item-text="descricao"
        label="Turma"
        return-object
        @change="findDisciplinaInProfDisc"
        placeholder="Turma"
        outlined
        dense
        hide-details
        data-tour="turma"
      ></v-combobox>
    </v-col>

    <v-col md="3">
      <v-combobox
        :items="disciplinas"
        v-model="disciplinaSelected"
        item-text="descricao"
        label="Disciplina"
        return-object
        @change="pautaByTurma"
        placeholder="Disciplina"
        outlined
        dense
        hide-details
        data-tour="disciplina"
      ></v-combobox>
    </v-col>
  </v-row>
</v-card-text>


                          </v-col>
                        </v-row>
                      </v-header>
                      
                       <formulario-notas
                          :lista="listEstudantfromPauta"
                          :colunasNotas="colunasNotas"
                          :pautaBloqueada="pautaBloqueada"
                          :editedpk="editedpk"
                          :editedItem="editedItem"
                          :btn_activacao1="btn_activacao1"
                          :notaRules="notaRules"
                          @editar="bt_edit"
                          @salvar="bt_save"
                        />
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>

        <v-tour name="notas-tour" :steps="tourSteps" @finished="handleTourFinished"  @stop="handleTourSkipped" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../../plugins/axios";
import photostudent from "../../../utilitarios/photo.services";
import Swal from "sweetalert2";
import FormularioNotas from './componentes/FormularioNotas.vue';
const ls = require("local-storage");
export default {
  components:{FormularioNotas},
  data: () => ({
    formValid: true,
    estiloPauta: "position:fixed;background-color:green;color:white;",
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      (value) => !!value || "campo obrigatório.",
      (v) => (v >= 0 && v <= 20) || "nota invalida",
      (v) => !isNaN(v) || "not number ",
      (value) => {
        const pattern = /^[+-]?\d+(\.\d+)?$/;
        return pattern.test(value) || "Invalido.";
      },
      (v) => ( v !== null && v.length <= 4)|| "valor inválido",
    ],
    text: "",
    editedpk: 0,
    profediscinas: [],
    anolectivoSelected:null,
    tipoNotaSelected: null,
    trimestreSelected:null,
    tiposNota:[],
    diasDesbloqueio: [
      { id: 1, descricao: "1 dia" },
      { id: 2, descricao: "2 dias" },
      { id: 3, descricao: "3 dias" },
      { id: 4, descricao: "4 dias" },
      { id: 5, descricao: "5 dias" },
    ],
    classes: [
      { id: 1, descricao: "10ª classe" },
      { id: 2, descricao: "11ª classe" },
      { id: 3, descricao: "12ª classe" },
      { id: 4, descricao: "13ª classe" },
    ],
    classesFiltered:[],
    colunasNotaITrimestre:
    [
      { key: 'p1_notaMac', label: 'Mac' },
      { key: 'p1_nota', label: 'PP' },
      { key: 'p1_nota2', label: 'P2' },
      { key: 'p1_MD', label: 'MD' }
    ],
    colunasNotaIITrimestre:
    [
      { key: 'p2_notaMac', label: 'Mac' },
      { key: 'p2_nota', label: 'PP' },
      { key: 'p2_nota2', label: 'P2' },
      { key: 'p2_MD', label: 'MD' }
    ],
    colunasNotaIIITrimestre:
    [
      { key: 'p3_notaMac', label: 'Mac' },
      { key: 'p3_nota', label: 'PP' },
      { key: 'p3_nota2', label: 'P2' },
      { key: 'p3_MD', label: 'MD' }
    ],
    colunasNotaNaoTrimestral: // Nota finalista
    [
      { key: 'notaNaoTrimestral', label: 'Nota' },
    ],
    colunasExame:
    [
      { key: 'pg', label: 'Nota' },
    ],

    colunasRecurso:
    [
      { key: 'recurso', label: 'Nota' },
    ],

    tourSteps: [
      {
        target: '[data-tour="anolectivo"]',
        content: 'Selecione o ano lectivo que pretende lançar as notas.'
      },
      {
        target: '[data-tour="tiponota"]',
        content: 'Selecione o tipo de nota que pretende lançar. As opções incluem: Iº Trimestre, IIº Trimestre, IIIº Trimestre, Nota Finalista, Exame, Recurso ou Exame Especial.'
      },
      {
        target: '[data-tour="classe"]',
        content: 'Selecione a classe dos alunos.'
      },
      {
        target: '[data-tour="turma"]',
        content: 'Agora selecione a turma específica.'
      },
      {
        target: '[data-tour="disciplina"]',
        content: 'Por fim, escolha a disciplina da nota a ser lançada.'
      }
    ],

    colunasNotas:[],
    pautaBloqueada: false,
    objBloqueioPauta: null,
    turmaSelected: null,
    overlay: false,
    descricaoNota:"",
    role_usuario: "",
    disciplinas: [],
    tourNotasAtivo: false,
    Listaranoslectivo: [],
    _classe: "",
    snackbar: false,
    txt:'',
    Professor: "",
    dialog: false,
    dialogoDisabilita: false,
    progresso_2: false,
    progresso_3: false,
    lancamentoSelected: 1,
    progresso: true,
    disciplinaSelected: null,
    idanoacademico: 0,
    offset: true,
    descricao_Prof: "",
    tumaSelect: "",
    iddisciplina: 0,
    btn_description: "",
    publicar_status: false,
    idturma: 0,
    closeOnClick: true,
    objAnolectivo: null,
    item: 1,
    listaPautasBloquadas: [],
    btn_activacao1: false,
    btn_activacao2: false,
    btn_activacao3: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    roles: "prof",
    classeSelected: null,
    items: [
      { id: 1, descricao: "Nota por nota" },
      { id: 2, descricao: "Todas as notas" },
    ],
    editedIndex: -1,
    editedItem: {
      dayValidity: null,
      pkpauta: 0,
      anolectivo:null,
      tipoNota:null,
      notaNaoTrimestral:0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      recurso:0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0,
    },
  }),
  computed: {
    idclasse() {
      return this.$store.state.idclasse;
    },
    role() {
      return ls.get("role");
    },
    isAnolectivoNotaSelected() {
    return  this.anolectivoSelected !== null && this.tipoNotaSelected !== null
  },

  },

  watch: {
    listaDeClassesPorLancarNotas() {
      this.$store.state.isloading = false;
    },
  },

  mounted() {

    // this.iniciarTourNotas();
  
},
  created() {
    if (ls.get("role") === "ROLE_COOR") {
      this.roles = "coor";
    }

    
   
    this.objAnolectivo = this.$store.state.anolectivoLancamento;
    // this.CarregActividades()
   // this.turmaFindWithEstudanteCount("all");
    this.initprofdisc();
    this.initializeAnosLectivo()
    this.getTiposNotas()
    this.role_usuario = ls.get("role");
  },

  methods: {
    classe(idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = "10ª Classe";
      }
      if (idanoacademico === 2) {
        this._classe = "11ª Classe";
      }
      if (idanoacademico === 3) {
        this._classe = "12ª Classe";
      }
      if (idanoacademico === 4) {
        this._classe = "13ª Classe";
      }

      this.idanoacademico = idanoacademico;
    },
    loadprogressbar() {
      this.$store.state.isloading = true;
    },

    iniciarTourNotas() {
    this.tourNotasAtivo = true;
    this.$tours['notas-tour'].start();
  },

      isTourNotasAtivo() {
      return (
        this.$tours &&
        this.$tours['notas-tour'] &&
        this.$tours['notas-tour'].isRunning === true
      );
    },

    finalizarTourNotas() {
    this.tourNotasAtivo = false;
  },
    

    bt_edit(item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedpk = item.pkpauta;
      this.editedItem.trimestre = this.$store.state.idperfilpauta;
      this.editedItem.pkpauta = item.pkpauta;

      //setTimeout(() => {}, 1000);
    },
    MostrarDialogo() {
      this.dialog = true;
    },

    MostrarDialogoDisabilitar() {
      this.dialogoDisabilita = true;
    },
    bt_save(editedItem) {
       
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      );
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      );
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) + Number(editedItem.p3_nota)) / 2
      );
      if (this.formValid) {
        this.save(editedItem);

        this.editedpk = 0;
      }
      setTimeout(() => {}, 1000);
    },
    backTodisciplinList() {
      this.listEstudantfromPauta = [];
    },
    backToTurmaList() {
      this.disciplinas = [];
    },

    filtrarTurmas() {
      this.overlay = true;
      this.turmasFilter = [];
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      this.turmaSelected = null;
      this.turmasFilter = this.listaDeClassesPorLancarNotas.filter(
        (t) => t.idAno_Academico === this.classeSelected.id
      );
      this.overlay = false;
    },


    

     async initializeAnosLectivo() {
      try {
        let respose = await axios
          .get("/listarAnoLectivoAll2")
          .then((res) => res.data);

        this.Listaranoslectivo = respose.filter( f=>f.novadescricao !== ls.get('novadescricao') )
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    clearSelecoes() {
     this.classeSelected = null,
     this.turmaSelected = []
     this.disciplinaSelected = null;
     this.turmasFilter = []
     this.classesFiltered = []
     this.listEstudantfromPauta =  []
   },

   selectAnolectivo() {
    this.turmaFindWithEstudanteCount()
    this.clearSelecoes();
    if(this.tipoNotaSelected !== null)
       this.descricaoNota = this.getRota(this.tipoNotaSelected.descricao); // recarrega as classes,e as outras informaçções
  },

  selectTipoNota() {
    this.clearSelecoes();
    this.descricaoNota = this.getRota(this.tipoNotaSelected.descricao);
  },

    async getTiposNotas() {
      try {
        this.tiposNota = await axios
          .get("/getTipoNotas")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },

    async turmaFindWithEstudanteCount(idclasse) {
      this.progresso = true;
      try {
        this.progresso = true;
        this.listaDeClassesPorLancarNotas = await axios
          .get(
            "/turmaFindWithEstudanteCount/" +
              "all/" +
              this.anolectivoSelected.descricao
          ) // idclasse JyUn JQ==
          .then((res) => res.data);

          console.log(this.listaDeClassesPorLancarNotas, ' as turmas ');
          
        this.progresso = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
      this.listEstudantfromPauta = [];
    },

   normalizarNota(valor) {
      if (valor === null || valor === undefined) return valor;
      const str = valor.toString();
      return str.length <= 2 ? str + ".0" : str;
   },

  async save(editedItem) {
    if (!this.$refs.form.validate()) {
      this.$store.dispatch("textMessage", {
        msg: "Preencha todos os campos para salvar as notas.",
        classMessage: "msgError",
        timeout: 5000,
      });
      return;
    }

    if (this.role === "ROLE_ADM") {
      this.estiloPauta = "position:fixed;background-color:red;color:white;";
      this.$store.dispatch("textMessage", {
        msg: "Não é permitido ao administrador Lançar Notas ou altera-las.",
        classMessage: "msgError",
        timeout: 8000,
      });
      return;
    }

    const params = {
      p1_notaMac: this.normalizarNota(editedItem.p1_notaMac),
      p1_nota: this.normalizarNota(editedItem.p1_nota),
      p1_nota2: this.normalizarNota(editedItem.p1_nota2),
      p1_MD: this.normalizarNota(editedItem.p1_MD),
      p2_notaMac: this.normalizarNota(editedItem.p2_notaMac),
      p2_nota: this.normalizarNota(editedItem.p2_nota),
      p2_nota2: this.normalizarNota(editedItem.p2_nota2),
      p2_MD: this.normalizarNota(editedItem.p2_MD),
      p3_notaMac: this.normalizarNota(editedItem.p3_notaMac),
      p3_nota: this.normalizarNota(editedItem.p3_nota),
      p3_nota2: this.normalizarNota(editedItem.p3_nota2),
      p3_MD: this.normalizarNota(editedItem.p3_MD),
      pg: this.normalizarNota(editedItem.pg),
      ca: editedItem.ca,
      recurso: this.editedItem.recurso,
      nota: this.normalizarNota(editedItem.notaNaoTrimestral),
      notaNaoTrimestral:this.normalizarNota(editedItem.notaNaoTrimestral),
      mfd: editedItem.mfd,
      autor: ls.get("nomeUsuario"),
      pkpauta: editedItem.pkpauta,
      trimestre: this.trimestreSelected,
      urlApi: this.getUrlApiLancamento(),
      anolectivo: this.anolectivoSelected
    };

    try {
      let msg = await axios.post(params.urlApi, params).then((res) => res.data);

      if (msg.affectedRows >= 1) {
        this.text = msg.affectedRows + " gravado(s) com sucesso";
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgSucess",
          timeout: 2000,
        });
        Object.assign(this.listEstudantfromPauta[this.editedIndex], params);
      } else if (msg.message.sqlMessage !== undefined) {
        this.$store.dispatch("textMessage", {
          msg: msg.message.sqlMessage,
          classMessage: "msgError",
          timeout: 8000,
        });
      }
    } catch (error) {
      this.$store.dispatch("textMessage", {
        msg: error.message + " - " + error,
        classMessage: "msgError",
        timeout: 8000,
      });
    }
},

   handleTourFinished() {
      console.log("Tour concluído com sucesso!");
       
    },
    handleTourSkipped() {
      console.log("Usuário pulou o tour antes de terminar!");
      
    },
    
 
    async pautaByTurma() {
      // carrega turma apartir de bauta  Turma
      let obj = this.disciplinaSelected;
      this.$store.state.disciplina = obj.iddisciplina;
      this.$store.state.objDisciplina = obj;
      const payload =
        '{"iddisciplina":"' +
        obj.iddisciplina +
        '" , "pkturma":"' +
        obj.pkturma +
        '", "i_id":"' +
        ls.get("i_id") +
        '"  }';

      try {
        this.progresso_3 = true;
        this.listEstudantfromPauta = await axios

          .get("/listEstudantfromPauta/" + payload)
          .then((res) => res.data);

        this.progresso_3 = false;
        this.MostraProfessor();
        
      } catch (error) {
        // this.isLoading = false
        this.progresso_3 = false;
        // this.text = error
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initprofdisc(search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}';
        } else {
          payload = '{"find":"' + search + '"}';
        }
        this.profediscinas = await axios
          .get("/professordiscFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    getUrlApiLancamento(){

        const apis= {
            1:{
               tipoNota:'Iº trimestre',
               url:'/lancarNota'
            },
            2:{
              tipoNota:'IIº trimestre',
               url:'/lancarNota'
            },
            3:{
              tipoNota:'IIIº trimestre',
               url:'/lancarNota'
            },
            4:{
              tipoNota:'Finalista',
               url:'/lancarNotaFinalista-admin'
            },
            5:{
              tipoNota:'Exame',
               url:'/lancarNotaExame-admin'
            },
            6:{
              tipoNota:'Recurso',
               url:'/lancarNotaRecurso'
            },
            7:{
              tipoNota:'Exame Especial',
               url:'/lancarNotaExameEspecialAnterior'
            }
        }

        return apis[this.trimestreSelected].url

    },
 
    getRota(tipoNota) {
      const trimestres = {
        "Iº Trimestre": {
          colunas: this.colunasNotaITrimestre,
          label: "do Iº Trimestre",
          trimestre:1,
          classes: this.classes.filter( c=>c.id !== 4 )
        },
        "IIº Trimestre": {
          colunas: this.colunasNotaIITrimestre,
          label: "do IIº Trimestre",
          trimestre:2,
          classes: this.classes.filter( c=>c.id !== 4 )
        },
        "IIIº Trimestre": {
          colunas: this.colunasNotaIIITrimestre,
          label: "do IIIº Trimestre",
          trimestre:3,
          classes: this.classes.filter( c=>c.id !== 4 )
        },
        "Nota Finalista": {
          colunas: this.colunasNotaNaoTrimestral,
          label: "Nota Finalista",
          trimestre:4, // Nota Finalista
          classes: this.classes.filter( c=>c.id === 4 )
        },
        "Nota Exame": {
          colunas: this.colunasExame,
          label: "Nota Exame",
          trimestre:5, // Nota de Exame
          classes: this.classes.filter( c=>c.id !== 4 )
        },
        "Nota de Recurso": {
          colunas: this.colunasRecurso,
          label: "Nota de Recurso",
          trimestre:6, // Nota de recurso
          classes: this.classes.filter( c=>c.id !== 4 )
        },
        "Nota de Exame Especial": {
          colunas: this.colunasNotaNaoTrimestral,
          label: "Nota de Exame Especial",
          trimestre:7, // Nota de exame especial
          classes: this.classes.filter( c=>c.id !== 4 )
        }
      };
        if (trimestres[tipoNota]) {
          this.colunasNotas = trimestres[tipoNota].colunas;
          this.trimestreSelected = trimestres[tipoNota].trimestre
          this.classesFiltered =  trimestres[tipoNota].classes
          return trimestres[tipoNota].label;
        }
    },
    
    
    

    MostraProfessor() {
      let valor = this.profediscinas.filter(
        (d) => d.iddisciplina === this.$store.state.disciplina
      );
      if (valor.length) {
        this.Professor = valor[0].nome;
        this.descricao_Prof = "disciplina atrbuida ao Professor";
      } else {
        this.Professor = "Sem Professor Associado";
        this.descricao_Prof = "";
      }
    },

     
     
    async findDisciplinaInProfDisc() {
      this.overlay = true;
      this.disciplinas = [];
      this.listEstudantfromPauta = [];
      this.disciplinaSelected = null;
      let obj = this.turmaSelected;
      this.disciplinas = [];
      this.$store.state.turma = obj.descricao;
      this.$store.state.objturma = obj;
      try {
        this.progresso_2 = true;
        this.disciplinas = await axios

          .get(
            "/findDisciplinaInProfDisc/" +
              obj.pkTurma +
              "/" +
              this.anolectivoSelected.descricao
          )
          .then((res) => res.data);
        this.progresso_2 = false;
        this.overlay = false;
      } catch (error) {
        // this.isLoading = false
        this.progresso_2 = false;
        this.overlay = false;
        // this.text = error
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar efectuar a operação",
          "error"
        );
      }
    },
  
  },
};
</script>
<style scoped>
 ::v-deep(.v-step) {
  background-color: #2196F3 !important; /* Cor primária */
  color: #ffffff !important; /* Texto branco */
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  font-family: 'Segoe UI', Roboto, sans-serif;
  font-size: 15px;
  line-height: 1.6;
}

/* Título dentro do step */
::v-deep(.v-step__header) {
  font-size: 18px;
  font-weight: 600;
  color: #FFC107; /* Amarelo - cor de destaque */
  margin-bottom: 0.5rem;
}

/* Botões do tour */
::v-deep(.v-step__button) {
  background-color: #FFC107; /* Cor warning */
  color: #424242; /* Secundária escura */
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 8px;
}

::v-deep(.v-step__button:hover) {
  background-color: #FFD54F; /* tom mais claro do warning */
  color: #212121; /* cinza ainda mais escuro */
}

/* Botão "pular" (skip) */
::v-deep(.v-step__button--skip) {
  background: transparent;
  color: #ffffff;
  text-decoration: underline;
  font-size: 13px;
  margin-right: auto;
}


</style>